import * as types from '../constants/actionTypes';

// set requestId as the errorId when request fails
// this state is primarily used inside <NoDataErrorForm>
export const setErrorId = err => ({
    type: types.SET_NO_DATA_ERROR,
    payload: err
});